export default (state = {}, payload) => {
  switch (payload.type) {
    case "GET_USER_COUNTRY_SUCCESS":
      return payload.data;

    default:
      return state;
  }
};
